import CONSTANTS from "./CONSTANTS";

/**
 * Expects:
 *  - questionSet = function to set question state
 *  - questionsDone = function to set questions loaded state
 *  - gender = the current character's gender
 *
 * Returns:
 *  - true if successful
 *  - false if unsuccessful
 */
const getQuestions = async (questionSet, questionsDone, gender) => {
	try {
		// Getting questions
		let questionsOriginal = await fetch(
			`${CONSTANTS.backend}api/question/?gender=${gender}`
		);
		questionsOriginal = await questionsOriginal.json();

		// Will store questions in format for state
		let questions = {};

		// Iterating over each quesiton and adding to correct age array
		for (let i = 0; i < questionsOriginal.length; i++) {
			// Creating a new age array if one does not yet exist
			if (!questions.hasOwnProperty(`age${questionsOriginal[i].age}`)) {
				questions[`age${questionsOriginal[i].age}`] = [];
			}

			// Adding question to correct age array
			questions[`age${questionsOriginal[i].age}`].push({
				questionTitle: questionsOriginal[i].title,
				questionBody: questionsOriginal[i].content,
				qYes: questionsOriginal[i].yes_question,
				qNo: questionsOriginal[i].no_question,
				qYesLog: questionsOriginal[i].yes_log,
				qNoLog: questionsOriginal[i].no_log,
			});
		}

		// Adding questions to state
		questionSet(questions);
		// Updating state
		questionsDone(true);

		return true;
	} catch (err) {
		console.log(`Error fetching: ${err}`);
		return false;
	}
};

export default getQuestions;
